import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  root: {
    borderTop: '1px solid black',
    borderBottom: '1px solid black',
    marginTop: '0.15em',
    padding: '0.25em'
  },
  rootReview: {
  },
  rootHold: {
  },
  commentSection: {
  },
  topRowSection: {
  },
  holdComment: {
    marginBlockEnd:'4px'
  },
  reviewComment: {
    marginBlockEnd:'4px'
  }
});

const HoldDataListItem = props => {
  const classes = useStyles();

  const isReview = props.holdReviewedBy.length > 0;

  return (
    <>
    <div className={`${classes.root} ${classes.rootHold}`}>

      {/* top row */}
      <div>
        {/* hold reason / hold reviewed */}
        <div className={classes.topRowSection}>
        <span>{props.encounterProcess} - </span>
          <span>
            Hold Reason: {props.holdReason} by {props.onHoldBy} on {props.onHoldOn}
          </span>
        </div>
      </div>
      <div className={classes.commentSection}>
        {
          props.holdComment && props.holdComment.length > 0
            ? (
              <p className={classes.holdComment}>
                Hold Comment: {props.holdComment}
              </p>
            )
            : null
        }
      </div>
    </div>

      {
        props.reviewComment && props.reviewComment.length > 0
          ? (
            <div className={`${classes.root} ${classes.rootReview}`}>
              <div>
                <div className={classes.topRowSection}>
                  <span>{props.encounterProcess} - </span>
                  <span>
                    Hold Reviewed by {props.holdReviewedBy} on {props.holdReviewedOn}
                  </span>
                </div>
              </div>
              <div className={classes.commentSection}>
                <p className={classes.reviewComment}>
                  Review Comment: {props.reviewComment}
                </p>
              </div>
            </div>
            )
          : null
      }

    </>
  );
};

HoldDataListItem.propTypes = {
  onHoldBy: PropTypes.string.isRequired,
  onHoldOn: PropTypes.string.isRequired,
  holdReason: PropTypes.string.isRequired,
  encounterProcess: PropTypes.string.isRequired,
  holdReviewedBy: PropTypes.string.isRequired,
  holdReviewedOn: PropTypes.string.isRequired,
  holdComment: PropTypes.string.isRequired,
  reviewComment: PropTypes.string,
  holdRemovedOn: PropTypes.string.isRequired
};

export default HoldDataListItem;
